import Vue from 'vue';

const EventBus = new Vue();

// mixin for components to toggle the global loading indicator
const GlobalLoaderMixin = {
  methods: {
    showGlobalLoader(msg) {
      EventBus.$emit('show-global-loader', msg);
    },
    hideGlobalLoader() {
      EventBus.$emit('hide-global-loader');
    },
  },
};

export {
  EventBus,
  GlobalLoaderMixin,
};
